import { Add, MailOutlined } from '@mui/icons-material';
import { Button } from 'finara-components';
import React, { useState } from 'react';

import {
  AddClientModal,
  ClientSearchFilters,
  ClientSummaryCards,
  ClientTable,
  InviteAdminModal,
} from '../../../components/super-admin/clients';
import { Navbar } from '../../../components/super-admin/general';
import { superAdminNavItems } from '../../../data/super-admin/general/navigationData';

export const ClientListPage: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [typeFilter, setTypeFilter] = useState('all');
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);

  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };

  const handleStatusFilter = (status: string) => {
    setStatusFilter(status);
  };

  const handleTypeFilter = (type: string) => {
    setTypeFilter(type);
  };

  const handleAddClient = () => {
    setIsAddModalOpen(true);
  };

  const handleModalSuccess = () => {
    // Modal will trigger query invalidation through the mutation
    // The ClientTable and ClientSummaryCards will automatically refresh
  };

  return (
    <div className="min-h-screen">
      <Navbar navItems={superAdminNavItems} activeItem="Clientes" userName="A Admin" />

      <div className="pt-6">
        {/* Page Header */}
        <div className="mb-[21px]">
          <div className="flex justify-between items-start mb-4">
            <div>
              <h1 className="text-[21px] font-bold text-brand-white">Listado de Clientes</h1>
              <p className="text-muted text-sm">Gestiona todos los clientes de la plataforma</p>
            </div>
            <div className="flex gap-3">
              <Button
                variant="white"
                startIcon={<MailOutlined fontSize="small" />}
                onClick={() => setIsInviteModalOpen(true)}
              >
                Invitar Cliente (Onboarding)
              </Button>
              <Button
                variant="black"
                startIcon={<Add fontSize="small" />}
                onClick={handleAddClient}
              >
                Crear Cliente
              </Button>
            </div>
          </div>
        </div>

        {/* Summary Cards */}
        <div className="mb-[21px]">
          <ClientSummaryCards />
        </div>

        {/* Search and Filters */}
        <div className="mb-6">
          <ClientSearchFilters
            onSearch={handleSearch}
            onStatusFilter={handleStatusFilter}
            onTypeFilter={handleTypeFilter}
          />
        </div>

        {/* Client Table */}
        <ClientTable
          searchQuery={searchQuery}
          statusFilter={statusFilter}
          typeFilter={typeFilter}
        />
      </div>

      {/* Add Client Modal - instant creation, no KYC */}
      <AddClientModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onSuccess={handleModalSuccess}
      />

      {/* Invite Admin Modal - onboarding funnel + KYC review */}
      <InviteAdminModal isOpen={isInviteModalOpen} onClose={() => setIsInviteModalOpen(false)} />
    </div>
  );
};
